import React, { useContext, useEffect, useRef, useState } from 'react';
import { LangContext } from '../../contexts/langContext';
import { SocialContext } from '../../contexts/socialContext';
import { StateContext } from '../../contexts/stateContext';
import { Button } from './Button';
import { EditName, parseGroupDescription } from './EditName';
import { Icon } from './Icon';
import { PopoverH } from './TooltipH';
import { WithVersion } from './VersionToggler';


export function SocialTabs({ active = 'all', handleChange = () => void (0) }) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  const tabsRef = useRef(null);

  const [activeTab, setActiveTab] = useState(active)

  useEffect(() => {
    const fakeTab = active === 'all' || active === 'celebs';
    if (!fakeTab && Array.isArray(context.groups) && context.groups.findIndex(group => group.token === active) < 0) {
      setActiveTab('all')
      handleChange('all')
      return
    }
    if (active && active !== activeTab) {
      setActiveTab(active)
    }
  }, [active, context.groups])

  useEffect(() => {
    const container = tabsRef.current;
    if (!container || !activeTab) return;

    const scrollToActive = () => {
      if (activeTab === 'all') {
        container.scrollTo({ left: 0, behavior: 'smooth' });
        return;
      }
      const tabEl = container.querySelector(`[data-token="${activeTab}"]`);
      if (!tabEl) return;
      const left = tabEl.offsetLeft - (container.clientWidth - tabEl.offsetWidth) / 2;
      container.scrollTo({ left: Math.max(0, left), behavior: 'smooth' });
    };

    const raf = requestAnimationFrame(() => requestAnimationFrame(scrollToActive));
    return () => cancelAnimationFrame(raf);
  }, [activeTab, context.groups])


  const getGroupData = (group) => {
    const groupData = parseGroupDescription(group.description);
    return {
      token: group.token,
      name: group.name,
      image: groupData.image || null,
      image2: groupData.image2 || null,
      description: groupData.description || null,
      invitation: Boolean(group.invitation)
    }
  }

  return (
    <>
      <div className="x_choose_tabs0">
        <div className="x_choose_tabs x_choose_tabs--v" ref={tabsRef}>

          <Tab 
            name={'All'}
            token={'all'}
            handleChange={handleChange} 
            active={activeTab === 'all' ? true : false} 
            image={null}
            image2={null}
            description={null}
          />

          <Tab
            name={''}
            token={'celebs'}
            icon='star'
            handleChange={handleChange}
            active={activeTab === 'celebs'}
            image={null}
            image2={null}
            description={null}
          />

          {(context.groups || []).map(one => {
            return <Tab 
              key={one.token} 
              active={activeTab === one.token ? true : false} 
              handleChange={handleChange} 
              icon={one.invitation ? 'mail' : 'group'}
              {...getGroupData(one)}
            />
          })}

          <WithVersion>
            <div className="x_choose_tabs_create _f">
              <PopoverH
                title={<EditName
                  name={''}
                  placeholder={$ui('group_set_name_placeholder')}
                  placement='bottom'
                  handleUpdate={(newName) => {
                    context.x.createGroup({
                      'name': newName,
                      'description': ''
                    })
                  }}
                />}>
                <div >
                  <Button ghost icon='add'></Button>
                </div>
              </PopoverH>
            </div>
          </WithVersion>


        </div>
      </div>

    </>
  )
}




export default function Tab({ 
  invitation = false,
  name, 
  image,
  image2,
  description,
  active, 
  token, 
  icon = 'group',
  handleChange = () => void (0) 
}) {
  const context = { ...useContext(SocialContext), ...useContext(StateContext), ...useContext(LangContext) };
  const $ui = context.$ui;
  return (
    <div className="x_choose_tabs_tab0" data-token={token} onClick={() => handleChange(token)}>
            {invitation && <div className="x_noti0"></div>}
      <div className={`x_choose_tabs_tab1 ${active ? 'active' : ''}`}>
        <svg width={20} height={56} viewBox="0 0 20 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M10.3052 7.83977C11.2836 3.26724 15.324 0 20 0V0V56H0L10.3052 7.83977Z" fill="#FEF9F4" />
        </svg>
      </div>
      <div className={`x_choose_tabs_tab ${active ? 'active' : ''}`}>
        <div className="x_choose_tabs_tab_inner"> 
          {Boolean(image) && <div className="x_choose_tabs_tab_name_icon" style={{ backgroundImage: `url(${image})` }} />}
          {!Boolean(image) && <div className="x_choose_tabs_tab_name_icon"><Icon>{icon}</Icon></div>}
          {Boolean(name) && <div className="x_choose_tabs_tab_name">
            {name}
          </div>}
        </div>
      </div>
      <div className={`x_choose_tabs_tab1 ${active ? 'active' : ''}`}>
        <svg width={20} height={56} viewBox="0 0 20 56" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9.69478 7.83977C8.71636 3.26724 4.67603 0 0 0V0V56H20L9.69478 7.83977Z" fill="#FEF9F4" />
        </svg>
      </div>
    </div>

  )
}
